export const links = {
  unit: 'https://en.wikipedia.org/wiki/1',
  prime: 'https://en.wikipedia.org/wiki/Prime_number',
  primeFactorization: 'https://en.wikipedia.org/wiki/Integer_factorization#Prime_decomposition',
  composite: 'https://en.wikipedia.org/wiki/Composite_number',
  repdigit: 'https://en.wikipedia.org/wiki/Repdigit',
  palindromic: 'https://en.wikipedia.org/wiki/Palindromic_number',
  threePalindromes: 'https://somethingorotherwhatever.com/sum-of-3-palindromes/',
  semiprime: 'https://en.wikipedia.org/wiki/Semiprime',
  twinPrime: 'https://en.wikipedia.org/wiki/Twin_prime',
  cousinPrime: 'https://en.wikipedia.org/wiki/Cousin_prime',
  safePrime: 'https://en.wikipedia.org/wiki/Safe_and_Sophie_Germain_primes',
  pythagoreanPrime: 'https://en.wikipedia.org/wiki/Pythagorean_prime',
  sophieGermainPrime: 'https://en.wikipedia.org/wiki/Safe_and_Sophie_Germain_primes',
  mersenne: 'https://en.wikipedia.org/wiki/Mersenne_prime',
  abundant: 'https://en.wikipedia.org/wiki/Abundant_number',
  factorial: 'https://en.wikipedia.org/wiki/Factorial',
  highlyComposite: 'https://en.wikipedia.org/wiki/Highly_composite_number',
  regular: 'https://en.wikipedia.org/wiki/Regular_number',
  triangular: 'https://en.wikipedia.org/wiki/Triangular_number',
  happy: 'https://en.wikipedia.org/wiki/Happy_number',
  untouchable: 'https://en.wikipedia.org/wiki/Untouchable_number',
  unfunny: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ'
};